import Cell from './Cell'

export default class SimpleSpace extends Cell {
    public walkThrough = true
}
